import React, {useContext} from 'react';

import {classNames} from '~/src/utilities/helpers/css';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './Blocker.module.scss';
import i18nStrings from './Blocker.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

const EmbedBlocker = () => {
    const {siteArea} = useContext(SettingsContext);

    const giveFullConsent = () => window.OneTrust && window.OneTrust.AllowAll();
    const editConsent = () => window.OneTrust && window.OneTrust.ToggleInfoDisplay();

    const blockerClassNames = classNames(css, 'embedBlocker', siteArea);

    return (
        <div className={blockerClassNames} data-testid="EmbedBlocker">
            <h5 className={css.header}>{getTranslation('title')}</h5>
            <p className={css.hint}>{getTranslation('description')}</p>
            <button className={css.acceptButton} onClick={giveFullConsent} data-testid="ConsentAcceptButton">
                {getTranslation('accept')}
            </button>
            <button className={css.editButton} onClick={editConsent} data-testid="ConsentEditButton">
                {getTranslation('edit')}
            </button>
        </div>
    );
};

export default EmbedBlocker;
